import { authInstance } from './axios';
import { filterParams, fixResponseJSON } from '../assets/helpers/funciones';
let url = process.env.REACT_APP_API_URL;

export const paymentsService = {
  createMembershipPayment: async (data) => {
    const response = await authInstance
      .post(`${url}/payments/createMembershipPayment`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  editPayment: async (data) => {
    const response = await authInstance
      .put(`${url}/payments/update`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  editCash: async (file, id) => {
    const myInit = {
      headers: {
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      method: 'PUT',
      body: file,
    };

    const response = await fetch(`${url}/paymentChange/update/${id}`, myInit)
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  createPendingPayment: async (data) => {
    const response = await authInstance
      .post(`${url}/payments/createMembershipPendingPayment`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  listUncheckedPayments: async (params) => {
    const response = await authInstance
      .get(`${url}/payments/list?` + new URLSearchParams(filterParams(params)))
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  checkLinkedPayments: async (data) => {
    const response = await authInstance
      .post(`${url}/payments/membershipsLinked`, data)

      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  listPaymentChanges: async (params) => {
    const response = await authInstance
      .get(
        `${url}/paymentChange/list?` + new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  validatePayment: async (data) => {
    const response = await authInstance
      .post(`${url}/payments/validatePayment`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  listAdvancedPayment: async (params) => {
    const response = await authInstance
      .get(
        `${url}/advancedPayment/?` + new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  createAdvancedPayment: async (data) => {
    const response = await authInstance
      .post(`${url}/advancedPayment/create`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  updateAdvancedPayment: async (id, data) => {
    const response = await authInstance
      .put(`${url}/advancedPayment/${id}/update`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  addMembershipPayment: async (id, data) => {
    const response = await authInstance
      .post(`${url}/payments/addMembershipPayment/${id}`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  editGiftcardPayment: async (data) => {
    const response = await authInstance
      .put(`${url}/payments/updateGiftCardPayment`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },
};
